export const Role = {
  ROOT_ADMIN: 'Root Admin',
  EPMO_MANAGER: 'Epmo Manager',
  EPMO_OFFICER: 'Epmo Officer',
  VICE_PRESIDENT: 'Vice President',
  PRESIDENT: 'President',
  PORTFOLIO_MANAGER: 'Portfolio Manager',
  PROGRAM_MANAGER: 'Program Manager',
  PROJECT_SPONSOR: 'Project Sponsor',
  PROJECT_OWNER: 'Project Owner',
  PROJECT_MANAGER: 'Project Manager',
  MEMBER: 'Member',
  MENTOR: 'Mentor'
}
